// extracted by mini-css-extract-plugin
export default {"counter-offer-modal":"styles__counter-offer-modal---gt26","modal-title":"styles__modal-title--sa+gA","counter-offer-modal-mobile":"styles__counter-offer-modal-mobile--HU5S4"};